import * as React from 'react';
import { DropDownListChangeEvent } from '@progress/kendo-react-dropdowns';
import { GridCustomFilterCellProps } from '@progress/kendo-react-grid';
import { Button } from '@progress/kendo-react-buttons';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { GetString } from '../StringResourceManager';
import { registrationStatusesNameMap } from '../../utils/textMappings';
import { filterClearIcon } from '@progress/kendo-svg-icons';
import { HeaderTdElement } from '@progress/kendo-react-data-tools';
import DynamicDropDownList from '../DynamicDropDownList';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    spaceBetween: {
      marginInline: 2,
    },
  })
);

interface RegistrationStatusDropDownFilterCellProps
  extends GridCustomFilterCellProps {
  defaultItem: string;
  data: string[];
  onChangeValueCheckFunc: (event: any) => any;
}

export const RegistrationStatusDropDownFilterCell = (
  props: RegistrationStatusDropDownFilterCellProps
) => {
  const selectedValue = GetString(registrationStatusesNameMap(props.value));

  let hasValue: any = (value: string) =>
    Boolean(value !== undefined && value !== '' && value !== props.defaultItem);

  const onChange = (event: DropDownListChangeEvent) => {
    hasValue = hasValue(event.target.value);

    props.onChange({
      value: hasValue ? props.onChangeValueCheckFunc(event.target.value) : '',
      operator: hasValue ? 'eq' : '',
      syntheticEvent: event.syntheticEvent,
    });
  };

  const onClearButtonClick = (event: React.MouseEvent<HTMLElement>) => {
    if (event) event.preventDefault();
    props.onChange({
      value: '',
      operator: '',
      syntheticEvent: event,
    });
  };

  const classes = useStyles();

  return (
    <HeaderTdElement
      columnId={props.thProps?.columnId || ''}
      {...props.thProps}
    >
      <div className="k-filtercell">
        <DynamicDropDownList
          data={props.data}
          onChange={onChange}
          value={hasValue(props.value) ? selectedValue : props.defaultItem}
          defaultItem={props.defaultItem}
        />
        <div className={classes.spaceBetween} />
        <Button
          title="Clear"
          disabled={!hasValue(props.value)}
          onClick={onClearButtonClick}
          svgIcon={filterClearIcon}
        ></Button>
      </div>
    </HeaderTdElement>
  );
};
